import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import TrustStrip from "./TrustStrip";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";
import StickyMobileCTA from "./StickyMobileCTA";
import ExitIntentModal from "./ExitIntentModal";
import SocialProofToast from "./SocialProofToast";
import GAPageTracker from "./GAPageTracker";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <GAPageTracker />
      <AnnouncementBar />
      <Navbar />
      <main
        className="flex-1 pb-24 lg:pb-0"
        style={{ paddingTop: "calc(var(--ab-height, 0px) + 5rem)" }}
      >
        <TrustStrip />
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
      <ExitIntentModal />
      <SocialProofToast />
      <Toaster position="top-center" richColors />
    </div>
  );
}
